import React from 'react';
import PropTypes from 'prop-types';
import {
  DataGridBody,
  DataGridRow,
  DataGrid,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridCell,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Button,
  mergeClasses,
} from '@fluentui/react-components';

import {
  useSummaryResultDialogStyles,
} from '../../styles/summary-result-dialog-style';

export const SummaryResultModal = ({
  show,
  title,
  summary,
  items,
  columns,
  columnSizingOptions,
  onClose,
  i18n,
}) => {
  const classes = useSummaryResultDialogStyles();

  return (
    show ?
      <Dialog
        open={show}
        modalType="modal"
      >
        <DialogSurface className={mergeClasses('summary-result-modal', classes.dialog)}>
          <DialogTitle className="summary-title">{title}</DialogTitle>
          <DialogBody>
            <DialogContent>
              <div className={mergeClasses('summary-description', classes.summaryMessage)}>{summary}</div>
              <div className={mergeClasses('summary-list-container', classes.summaryListContainer)}>
                <DataGrid
                  columns={columns}
                  items={items}
                  className={classes.grid}
                  resizableColumns
                  columnSizingOptions={columnSizingOptions}
                >
                  <DataGridHeader>
                    <DataGridRow>
                      {
                      item => (
                        <DataGridHeaderCell className={classes.gridHeaderCell}>{item.onRenderHeader(item)}</DataGridHeaderCell>
                      )
                    }
                    </DataGridRow>
                  </DataGridHeader>
                  <DataGridBody>
                    {
                    ({ item, rowId }) => (
                      <DataGridRow key={rowId}>
                        {
                          columnItem => (
                            <DataGridCell className={classes.gridCell}>{columnItem.onRender(item)}</DataGridCell>
                          )
                        }
                      </DataGridRow>
                    )
                  }
                  </DataGridBody>
                </DataGrid>
              </div>
            </DialogContent>
            <DialogActions position="start">
              <Button onClick={onClose} name="done" >{i18n.getString(_TL_('Done'))}</Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog> : null
  );
};

SummaryResultModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  summary: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onClose: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  columnSizingOptions: PropTypes.shape({}).isRequired,
};

SummaryResultModal.defaultProps = {
  summary: '',
};
